<template>
  <div>
    <div class='tip'>{{ opening_time }}</div>
    <div class="page">
      <!-- <a :href="'tel:' + tel"
         class="tel-link"> -->
      <div class='service-ways' @click="baiduPhone">
        <img :src="require('@/assets/skins/' + platformInfo.skin + '/tabbar_icon_service@3x.png')" class='service-icon' />
        <div class='service-main'>
          <div class='service-title'>
            在线客服
          </div>
          <div class='service-addition'>
            实时为您解决问题
          </div>
        </div>
        <div class='pointer'>
          <img src='../assets/icon_arrow.png' class='point' />
        </div>
      </div>
      <!-- </a> -->
      <div id='question-container'>
        <div id='question-title'>
          常见问题
          <router-link to="feedback" class="fbwrap">
            <img class="fbimg" src="@/assets/service_icon_feedback@3x.png" />
            反馈与建议
          </router-link>
        </div>

        <div v-for="(item, index) in QA" :key="index">
          <div class='question' @click="showAnswer(index)" :data-index='index'>
            <div class='question-word'>{{ item.name }}</div><img
              :src='item.opening === "1" ? require("../assets/up.png") : require("../assets/down.png")'
              class='question-icon' />
          </div>
          <div class='answer' v-show='item.opening === "1"'>
            {{ item.text }}
          </div>
        </div>
      </div>
      <div class="main_info">
        <div @click="infoFlag = true" class="p20">主体信息</div>
      </div>
      <div class="xieyi" v-if="name">使用本产品服务表示您已同意<br /><span class="xieyitxt" @click="goAgree">《{{ name
      }}隐私协议》</span>和<span v-if="znAgreementInfo && znAgreementInfo.user" class="xieyitxt" @click="goUserAgree">《{{
  name }}用户协议》</span></div>
    </div>
    <div v-if="infoFlag" @click="infoFlag = false">
      <div class="info_mask"></div>
      <img v-if="platformInfo.operateInfo === 'mo'" class="info_img"
        src="https://leqi-public.oss-cn-shanghai.aliyuncs.com/applet_image/business_license/moNengChen.jpg" />
      <img v-if="platformInfo.operateInfo === 'zhao'"
        src="https://leqi-public.oss-cn-shanghai.aliyuncs.com/applet_image/business_license/zhaoJian.jpg"
        class="info_img" />
      <img v-if="platformInfo.operateInfo === 'guan'"
        src="https://leqi-public.oss-cn-shanghai.aliyuncs.com/applet_image/business_license/yiGuan.png"
        class="info_img" />
      <img v-if="!platformInfo.operateInfo" class="info_img"
        src="https://leqi-public.oss-cn-shanghai.aliyuncs.com/applet_image/business_license/leqi.jpg" />
      <img v-if="platformInfo.operateInfo === 'leqi2'"
        src="https://leqi-public.oss-cn-shanghai.aliyuncs.com/applet_image/business_license/leqiO.jpg" class="info_img" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { agreement } from '@/utils/utils';
//智能项目组产品
let prolist = {
  '2018061560377443': {
    user: 'https://operating.applet.leqi.us/agreement.html?mark=bbc0cc98e42c586f20675a08f&key=%E6%94%AF%E4%BB%98%E5%AE%9D',
    private: 'https://operating.applet.leqi.us/agreement.html?mark=c7bbb0db9404896b198ffafa3&key=%E6%94%AF%E4%BB%98%E5%AE%9D'
  },
  'wx507a3308b839e8fe': {
    user: 'https://operating.applet.leqi.us/agreement.html?mark=bbc0cc98e42c586f20675a08f&key=%E5%BE%AE%E4%BF%A1',
    private: 'https://operating.applet.leqi.us/agreement.html?mark=c7bbb0db9404896b198ffafa3&key=%E5%BE%AE%E4%BF%A1'
  },
  'tta125d7983e0f2e0c': {
    user: 'https://operating.applet.leqi.us/agreement.html?mark=bbc0cc98e42c586f20675a08f&key=%E6%8A%96%E9%9F%B3',
    private: 'https://operating.applet.leqi.us/agreement.html?mark=c7bbb0db9404896b198ffafa3&key=%E6%8A%96%E9%9F%B3'
  },
  'ks667377173087294711': {
    user: 'https://operating.applet.leqi.us/agreement.html?mark=bbc0cc98e42c586f20675a08f&key=%E5%BF%AB%E6%89%8B',
    private: 'https://operating.applet.leqi.us/agreement.html?mark=c7bbb0db9404896b198ffafa3&key=%E5%BF%AB%E6%89%8B'
  },
  'wxc22626c10c142ab9': {
    user: 'https://operating.applet.leqi.us/agreement.html?mark=9477f37754ee08e30776af306&key=%E4%B8%80%E5%AF%B8%E8%AF%81%E4%BB%B6%E7%85%A7%E5%88%B6%E4%BD%9C',
    private: 'https://operating.applet.leqi.us/agreement.html?mark=bbf91e9f44fa1a8af2c28f61b&key=%E4%B8%80%E5%AF%B8%E8%AF%81%E4%BB%B6%E7%85%A7%E5%88%B6%E4%BD%9C'
  },
  'wx5dc88fc55693f38f': {
    user: 'https://operating.applet.leqi.us/agreement.html?mark=9477f37754ee08e30776af306&key=%E4%B8%80%E5%AF%B8%E8%AF%81%E4%BB%B6%E7%85%A7%E7%9B%B8%E6%9C%BA',
    private: 'https://operating.applet.leqi.us/agreement.html?mark=bbf91e9f44fa1a8af2c28f61b&key=%E4%B8%80%E5%AF%B8%E8%AF%81%E4%BB%B6%E7%85%A7%E7%9B%B8%E6%9C%BA'
  },
  'wx298c5a528a078c54': {
    user: 'https://operating.applet.leqi.us/agreement.html?mark=9477f37754ee08e30776af306&key=%E8%AF%81%E4%BB%B6%E7%85%A7%E7%A0%94%E7%A9%B6%E9%99%A2%E8%BD%AF%E4%BB%B6',
    private: 'https://operating.applet.leqi.us/agreement.html?mark=bbf91e9f44fa1a8af2c28f61b&key=%E8%AF%81%E4%BB%B6%E7%85%A7%E7%A0%94%E7%A9%B6%E9%99%A2%E8%BD%AF%E4%BB%B6'
  }
}


export default {
  computed: {
    ...mapState(["platformInfo"])
  },
  data() {
    return {
      infoFlag: false,
      QA: [],
      tel: '',
      opening_time: '',
      name: '',

      // 智能项目组产品 协议信息
      znAgreementInfo: {}
    }
  },
  created() {
    this.name = agreement(this.platformInfo.appId) ? agreement(this.platformInfo.appId).name : ''
    this.znAgreementInfo = prolist[this.platformInfo.appId]
    this.getService().then(res => {
      let { telephone, common_question, opening_time } = res.data;
      this.tel = telephone;
      this.QA = common_question;
      this.opening_time = opening_time;
    })
  },
  methods: {
    ...mapActions(["getService"]),
    baiduPhone() {
      // this.sdk.makePhoneCall(this.tel)
      console.log('点击“：：：', this.sdk)
      // 一些改为新的支付宝客服聊天窗口的appid
      let newCustomAppIdList = {
        '2021004104699180':'https://cschat.antcloud.com.cn/index.htm?tntInstId=0DL_DLIf&scene=SCE01278908',
        '2018011801952343':'https://cschat.antcloud.com.cn/index.htm?tntInstId=0DL_DLIf&scene=SCE01279258',
        '2018070960536689':'https://cschat.antcloud.com.cn/index.htm?tntInstId=0DL_DLIf&scene=SCE01279264',
        '2019092767826546':'https://cschat.antcloud.com.cn/index.htm?tntInstId=0DL_DLIf&scene=SCE01279265',

        'wx507a3308b839e8fe':'https://gbceyx2ejrewm.cschat.antcloud.com.cn/index.htm?tntInstId=0DL_DLIf&scene=SCE01278903',
        'wxae06cebe2e0f9042':'https://gbceyx2ejrewm.cschat.antcloud.com.cn/index.htm?tntInstId=0DL_DLIf&scene=SCE01278966',
        'wx303e650f9b81ba59':'https://gbceyx2ejrewm.cschat.antcloud.com.cn/index.htm?tntInstId=0DL_DLIf&scene=SCE01279242',
        'wxc22626c10c142ab9':'https://gbceyx2ejrewm.cschat.antcloud.com.cn/index.htm?tntInstId=0DL_DLIf&scene=SCE01279250',
        'wxb6c9cbf839ed8be4':'https://gbceyx2ejrewm.cschat.antcloud.com.cn/index.htm?tntInstId=0DL_DLIf&scene=SCE01279252',
        'wxd7cc9be3acc4e033':'https://gbceyx2ejrewm.cschat.antcloud.com.cn/index.htm?tntInstId=0DL_DLIf&scene=SCE01279254',
        'wx298c5a528a078c54':'https://gbceyx2ejrewm.cschat.antcloud.com.cn/index.htm?tntInstId=0DL_DLIf&scene=SCE01279256',
        'wxf5a0289df1400306':'https://gbceyx2ejrewm.cschat.antcloud.com.cn/index.htm?tntInstId=0DL_DLIf&scene=SCE01288172',

        'ks667377173087294711':'https://cschat.antcloud.com.cn/index.htm?tntInstId=0DL_DLIf&scene=SCE01279413'
      }
      if(newCustomAppIdList[this.platformInfo.appId]){
        location.href = newCustomAppIdList[this.platformInfo.appId]
        return
      }
      this.sdk.qiyu()
    },
    goAgree() {
      if (this.znAgreementInfo.private) {
        window.location.href = this.znAgreementInfo.private
        return
      }
      this.$router.push('/agreement');
    },
    goUserAgree() {
      if (this.znAgreementInfo.user) {
        window.location.href = this.znAgreementInfo.user
      }
    },
    showAnswer(e) {
      console.log(e)
      let val = this.QA[e].opening;
      this.QA[e].opening = val === "0" ? "1" : "0";
    }
  }
}
</script>

<style scoped>
.info_mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
}

.info_img {
  position: fixed;
  top: .5rem;
  left: calc((3.75rem - 3.5rem)/2);
  width: 3.5rem;
  z-index: 2001;
}

.main_info {
  display: flex;
  justify-content: center;
  color: #666666;
  font-size: .14rem;
  text-decoration: underline;
}

.p20 {
  padding: 0.2rem 0.2rem 0;
}

.mint-tabbar .mint-tab-item.is-selected {
  background-color: #f9f9f9 !important;
  color: #333333 !important;
}

.mint-tabbar .mint-tab-item {
  background-color: #f9f9f9 !important;
  color: #a3a5ab !important;
}

.page {
  background: rgba(247, 247, 247, 1);
  padding: 0.1rem;
}

.service-ways {
  width: 3.54rem;
  height: 1rem;
  margin-bottom: 0.1rem;
  padding: 0.26rem 0.2rem 0.26rem 0.25rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.06rem;
  display: flex;
  align-items: center;
}

.service-icon {
  width: 0.48rem;
  height: 0.48rem;
}

.service-main {
  display: inline-block;
  width: 1.5rem;
  margin-left: 0.2rem;
}

.service-addition {
  margin-top: 0.05rem;
  color: rgba(153, 153, 153, 1);
  font-size: 0.12rem;
}

.tel-link {
  color: rgba(153, 153, 153, 1);
  text-decoration: none;
}

.service-title {
  font-size: 0.16rem;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}

.pointer {
  flex: 1;
  text-align: right;
}

#question-container {
  width: 3.55rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.06rem;
  height: auto;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
  padding-bottom: 0.08rem;
}

#question-title {
  height: 0.5rem;
  line-height: 0.5rem;
  color: rgba(153, 153, 153, 1);
  font-size: 0.14rem;
  border-bottom: 1px #efefef solid;
}

.question {
  height: 0.5rem;
  /* line-height: 0.5rem; */
  font-size: 0.14rem;
  color: rgba(51, 51, 51, 1);
  display: flex;
  align-items: center;
}

.fbwrap {
  float: right;
  font-size: 0.13rem;
  color: #666666;
  padding: 0 0.1rem;
  display: flex;
  align-content: center;
  text-decoration: none;
}

.fbimg {
  margin-right: 0.04rem;
  width: 0.12rem;
  align-self: center;
}

.question-word {
  width: 2.98rem;
}

.question-icon {
  width: 0.16rem;
}

.answer {
  padding: 0.16rem 0.19rem 0.16rem 0.19rem;
  color: rgba(102, 102, 102, 1);
  font-size: 0.13rem;
  background: rgba(247, 247, 247, 1);
  border-radius: 0.06rem;
}

.tip {
  width: 100vw;
  height: 0.5rem;
  background: rgba(255, 249, 240, 1);
  color: rgba(245, 166, 35, 1);
  font-size: 0.13rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.05rem;
}

.xieyi {
  margin: 0.05rem 0 0.1rem;
  text-align: center;
  font-size: 0.11rem;
  color: #999999;
}

.xieyitxt {
  color: rgb(35, 60, 255);
  padding: 0.08rem 0;
}
</style>
